import { component } from 'picoapp'
import $ from '../lib/quantdom'

export default component((node) => {
  var debounceTimeout

  //scroll track scrolled
  $(node)
    .find('[data-scroll-track]')
    .on('scroll', (e) => {
      clearTimeout(debounceTimeout)
      debounceTimeout = setTimeout(function () {
        updateArrowsFromScrollPosition(e.target.scrollLeft)
      }, 100)
    })

  //arrow left clicked
  $(node)
    .find('.js-arrow-left')
    .on('click', () => {
      scrollByClick('left')
    })

  //arrow right clicked
  $(node)
    .find('.js-arrow-right')
    .on('click', () => {
      scrollByClick('right')
    })

  const getPosition = (el) => {
    return parseInt($(el).attr('data-scroll-position'))
  }

  const setPosition = (el, position) => {
    $(el).attr('data-scroll-position', position)
  }

  /**
   * Update aria-hidden and tabindex on slides so screen readers
   * only announce the currently visible slide.
   */
  const updateSlideAccessibility = (activeIndex) => {
    const slides = node.querySelectorAll('[data-scroll-index]')
    slides.forEach((slide) => {
      const index = parseInt(slide.getAttribute('data-scroll-index'))
      if (index === activeIndex) {
        slide.setAttribute('aria-hidden', 'false')
        slide.removeAttribute('tabindex')
      } else {
        slide.setAttribute('aria-hidden', 'true')
        slide.setAttribute('tabindex', '-1')
      }
    })
  }

  const updateArrows = (scrollTrackEl) => {
    const totalSlides = parseInt($(scrollTrackEl).attr('data-scroll-length'))
    const currentPosition = getPosition(scrollTrackEl)
    const arrowLeft = $(node).find('.js-arrow-left').el()
    const arrowRight = $(node).find('.js-arrow-right').el()

    if (currentPosition <= 1) {
      arrowLeft.disabled = true
    } else {
      arrowLeft.removeAttribute('disabled')
    }
    if (currentPosition >= totalSlides) {
      arrowRight.disabled = true
    } else {
      arrowRight.removeAttribute('disabled')
    }
  }

  const updateArrowsFromScrollPosition = (pos) => {
    const scrollTrackEl = $(node).find('[data-scroll-track]').el()
    const slideWidth = scrollTrackEl.offsetWidth

    const newPosition = Math.round(pos / slideWidth) + 1
    setPosition(scrollTrackEl, newPosition)
    updateSlideAccessibility(newPosition)
    updateArrows(scrollTrackEl)
  }

  const scrollByClick = (direction) => {
    const scrollTrackEl = $(node).find('[data-scroll-track]').el()
    const totalSlides = parseInt($(scrollTrackEl).attr('data-scroll-length'))
    const slideWidth = scrollTrackEl.offsetWidth
    const position = getPosition(scrollTrackEl)
    const scrollToIndex = direction == 'right' ? position + 1 : position - 1

    // Don't scroll past bounds
    if (scrollToIndex < 1 || scrollToIndex > totalSlides) return

    const scrollToPx = scrollToIndex == 1 ? 0 : scrollToIndex * slideWidth - slideWidth / 2 - 1

    setPosition(scrollTrackEl, scrollToIndex)
    updateSlideAccessibility(scrollToIndex)
    updateArrows(scrollTrackEl)

    //Scroll to
    scrollTrackEl.scrollLeft = scrollToPx
  }
})
